export const entity = {
    name: 'Character',
    facets: [{name: 'codeName', nameOptional: false, uniqueName: true}],
}

export const module_ = {
    object: 'Character',
    tKey: 'mTitle_character',
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',
    category: {
        path: 'mTitle_animals',
        icon: 'animal'
    },
    viewMap: {
        dt: [
            'code', 'name'
        ],
        form: [
            'code', 'name'
        ]
    }
}
